module.exports = __webpack_public_path__ + "0d4d04d0a83b45c7ea224c63f5570fd9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ubuntu_Mono/UbuntuMono-Italic.ttf
// module id = 374
// module chunks = 0